module.exports = __webpack_public_path__ + "img/rimi2.8f071719.png";